/* eslint-disable func-names */
/* eslint-disable no-extend-native */
import isEmpty from 'lodash/isEmpty';

Object.defineProperty( Object.prototype, 'hasAllEmptyValues', {
	get: function hasAllEmptyValues() {
		return !isEmpty( this ) && Object.keys( this ).every( value => !this[ value ] );
	}
} );
